import type { RefObject } from "react";

export const handleScroll = (sliderRef: RefObject<HTMLDivElement>, isRTL: boolean): number => {
    let currentIndex = 0;
    if (sliderRef.current) {
        // Calculate the index of the focused element based on its position in the scroll container.
        const elements = sliderRef.current.getElementsByClassName("scrollable-element");

        // We loop over all the elements inside sliderRef.
        for (let index = 0; index < elements.length; index++) {
            const element = elements[index] as HTMLElement;

            // If a certain element is found, we break the loop and return the found index.
            const offset = 100; // An offset is needed because the previous and next images are also present on the screen.
            const { left, right } = element.getBoundingClientRect();
            const visible =
                (isRTL ? right : left) + offset >= 0 && (isRTL ? right : left) - offset <= window.innerWidth;

            if (visible) {
                currentIndex = index;
                break;
            }

            // If we reach the final element, use the last index instead of the (default) first index.
            if (index === elements.length) {
                currentIndex = index;
                break;
            }
        }
    }

    return currentIndex;
};

export const handleSlideButton = (
    direction: "left" | "right",
    currentSliderIndex: number,
    imageAmount: number,
): number => {
    let newPos = currentSliderIndex;
    if (imageAmount) {
        const firstElementIndex = 0;
        const lastElementIndex = imageAmount - 1;
        if (direction === "left") {
            if (currentSliderIndex > firstElementIndex) {
                newPos = currentSliderIndex - 1;
            }
        } else if (direction === "right") {
            if (currentSliderIndex < lastElementIndex) {
                newPos = currentSliderIndex + 1;
            }
        }
    }
    return newPos;
};
